import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { resolveRewardImageUrl } from "../utils/vioAssetUrl";

export default function useShakeFlow() {
  const { t } = useTranslation();
  const hasRewardToShow = useCallback((response) => (
    response.data?.reward &&
    (
      response.data?.entry?.rewardGranted === true ||
      response.data?.reward?.type === "token" ||
      response.data?.reward?.type === "voucher"
    )
  ), []);

  const getRewardDisplayName = useCallback((reward) => {
    if (reward.type === "token") {
      return reward.source || reward.tokenType || t("common.token");
    }

    let voucherName = reward.name || t("reward.fallbackVoucherName");
    voucherName = voucherName.replace(/^\$\d+\s+/i, "").replace(/\s+voucher$/i, "").trim();
    return voucherName || t("reward.fallbackVoucherName");
  }, [t]);

  const buildPresentedReward = useCallback((reward, name) => ({
    id: reward.id || reward._id || null,
    name,
    type: reward.type,
    imageUrl: resolveRewardImageUrl(reward),
    amount: reward.amount,
    source: reward.source || reward.tokenType,
    // VIO hasn't confirmed the send yet (pending / failed / unknown): the
    // prize is "being processed", never shown as delivered.
    pending: reward.deliveryStatus === "processing",
  }), []);

  return {
    hasRewardToShow,
    getRewardDisplayName,
    buildPresentedReward,
  };
}
